module.exports = __webpack_public_path__ + "img/icon-90.f0efad8a.png";